export default {
  data() {
    return {
      timers: {}
    }
  },
  methods: {
    setTimer(time, name) {
      this.clearTimer(name)
      // TODO: Do we still need the console.logs ?
      return new Promise((resolve, reject) => {
        if (time && typeof time === 'number') {
          console.log(`timer '${name}' set with time: ${time}`)
          this.timers[name] = setTimeout(() => {
            console.log(`timer ${name} expired`)
            resolve(name)
          }, time)
        } else {
          reject(new Error('time not provided'))
        }
      })
    },
    clearTimer(name) {
      if (name) {
        clearTimeout(this.timers[name])
      } else {
        Object.keys(this.timers).forEach(key => {
          clearTimeout(this.timers[key])
        })
      }
    }
  }
}
